import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FilesPage, FilesSearchSchema } from '@/features/files';

/** The Files app: recent files, the organisation's folders, shared spaces, search; the tab in the address. */
export const Route = createFileRoute('/_auth/o/$orgId/files')({
  validateSearch: (search) => FilesSearchSchema.parse(search),
  component: FilesRoute,
});

function FilesRoute() {
  const { orgId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <FilesPage
      orgId={orgId}
      tab={tab}
      onTabChange={(next) => {
        void navigate({ search: () => ({ tab: next }), replace: true });
      }}
    />
  );
}
